import { constant, flow, get } from 'lodash/fp';
import {
  createSelector,
  createStructuredSelector,
  defaultMemoize,
} from 'reselect';

import { getExperiment } from 'components/experiment/selectors';
import { formFromQuery, parseAdsSearch } from 'components/searchAds';
import { selectCarMakeValues } from 'store/ducks/manufacturers';
import { SEARCH_RESULTS_EXPERIMENT_CONFIG } from 'constants/gaExperiment';
import { getBreadcrumbsMetaFromCms } from 'helpers/cms';
import { VALUE_10 as DEFAULT_PAGE_SIZE } from 'helpers/fieldOptions/ad/pageSize';
import { getNumberOfResultsExpResult } from './selectors';

import { CMS_KEY, STORE_KEY } from './duck';

const getProps = (state, props) => props;

const getQueryFromLocation = createSelector(
  flow(getProps, get(['location', 'search'])),
  parseAdsSearch,
);

const getNumberOfResultsPerPage = createSelector(
  getNumberOfResultsExpResult,
  (numberOfResultsExp) => {
    let numberOfResults = Number(DEFAULT_PAGE_SIZE);

    if (numberOfResultsExp) {
      const { winnerVariant } = numberOfResultsExp;

      numberOfResults = get(
        ['resultsCount', winnerVariant],
        SEARCH_RESULTS_EXPERIMENT_CONFIG,
      );
    }

    return numberOfResults;
  },
);

const getInitialForm = createSelector(
  getQueryFromLocation,
  selectCarMakeValues,
  (query, carMakeValues) => formFromQuery(carMakeValues)(query),
);

const getBreadcrumbs = defaultMemoize(
  getBreadcrumbsMetaFromCms([STORE_KEY, CMS_KEY]),
);

export default createStructuredSelector({
  breadcrumbs: getBreadcrumbs,
  cms: get([STORE_KEY, CMS_KEY, 'result']),
  initialForm: getInitialForm,
  userSearchType: constant('default'),
  withExtraFilters: constant(true),
  withInitialAdResultsAmount: constant(false),
  withPromoBanner: constant(true),
  withWelcomeBanner: constant(false),
  storageKey: constant('generalSearch'),
  numberOfResultsPerPage: getNumberOfResultsPerPage,
  experiment: getExperiment,
});
